import { models } from '@vote4dance/judging-sdk';
var HeatsTeamItemSdk = models.teams.HeatsTeamItem;
export const HeatsTeamItem = HeatsTeamItemSdk;
export function calculatePlacementProgress(teams) {
    // Filter out teams with null placement
    const teamsWithPlacement = [...teams].filter((team) => team.heats_team_placement !== null);
    // Sort teams based on heats_team_placement in ascending order
    const sortedTeams = teamsWithPlacement.sort((a, b) => a.heats_team_placement - b.heats_team_placement);
    // Calculate unique placements
    const uniquePlacements = [];
    const percentages = sortedTeams.map((team, index) => {
        if (!uniquePlacements.includes(team.heats_team_placement)) {
            uniquePlacements.push(team.heats_team_placement);
        }
        return ((teamsWithPlacement.length - index) / teamsWithPlacement.length) * 100;
    });
    // Assign 0 percentage to teams with null placement
    return teams.map((team) => team.heats_team_placement !== null
        ? percentages[sortedTeams.findIndex((sortedTeam) => sortedTeam.heats_team_placement === team.heats_team_placement)]
        : 0);
}
export function calculateVoteProgressFromResults(teams, voteResults) {
    // Initialize aggregated votes
    const aggregatedVotes = {};
    // Check if voteResults is undefined
    if (!voteResults) {
        return teams.map(() => 0); // No votes, return 0 progress for all teams
    }
    // Parse and aggregate votes
    voteResults.forEach((row) => {
        if (!row.vote_results)
            return; // Skip if vote_results is null
        try {
            const votes = JSON.parse(row.vote_results);
            votes.forEach(({ heats_team_id, result_rating }) => {
                if (!aggregatedVotes[heats_team_id]) {
                    aggregatedVotes[heats_team_id] = 0;
                }
                aggregatedVotes[heats_team_id] += result_rating;
            });
        }
        catch (error) {
            console.error('Invalid JSON in vote_results:', row.vote_results, error);
        }
    });
    // Filter teams that have votes
    const teamsWithVotes = teams.filter((team) => aggregatedVotes[team.heats_team_id] !== undefined);
    // Sort teams based on votes in descending order
    const sortedTeams = teamsWithVotes.sort((a, b) => { var _a, _b; return ((_a = aggregatedVotes[b.heats_team_id]) !== null && _a !== void 0 ? _a : 0) - ((_b = aggregatedVotes[a.heats_team_id]) !== null && _b !== void 0 ? _b : 0); });
    // Calculate percentages based on ranks
    const percentages = sortedTeams.map((team, index) => {
        return ((teamsWithVotes.length - index) / teamsWithVotes.length) * 100;
    });
    // Assign percentages to all teams
    return teams.map((team) => aggregatedVotes[team.heats_team_id] !== undefined
        ? percentages[sortedTeams.findIndex((sortedTeam) => sortedTeam.heats_team_id === team.heats_team_id)]
        : 0);
}
